import { platformRoleAccess } from "helpers/RolesPermission";

/**
 * Tenant detail UI capabilities derived from platform permissions.
 */
export const resolveTenantDetailCapabilities = () => {
  const canViewBilling = platformRoleAccess("platform.billing.view");
  const canManageBilling = platformRoleAccess("platform.billing.manage");
  const canViewTenantUsers =
    platformRoleAccess("platform.user.search") ||
    platformRoleAccess("platform.tenant.users.create");
  const canCreateTenantUsers = platformRoleAccess("platform.tenant.users.create");
  const canEnterTenant = platformRoleAccess("platform.tenant.enter");
  const canStartGhost = platformRoleAccess("platform.ghost.start");
  const canSuspend = platformRoleAccess("platform.tenant.suspend");
  const canReadOnly = platformRoleAccess("platform.tenant.read_only");
  const canWildcard = platformRoleAccess("platform.tenant.wildcard");
  const canViewIntegrations = platformRoleAccess("platform.integrations.view");
  const canViewUsage = platformRoleAccess("platform.usage.view");
  const canViewAiUsage = platformRoleAccess("platform.ai_usage.view");
  const canViewAudit = platformRoleAccess("platform.audit.view");

  const canUseSupportTools =
    canSuspend ||
    canReadOnly ||
    canManageBilling ||
    canEnterTenant ||
    canStartGhost;

  const canOpenSupportDrawer = canUseSupportTools || canViewBilling;

  return {
    canViewBilling,
    canManageBilling,
    canViewTenantUsers,
    canCreateTenantUsers,
    canEnterTenant,
    canStartGhost,
    canSuspend,
    canReadOnly,
    canWildcard,
    canViewIntegrations,
    canViewUsage,
    canViewAiUsage,
    canViewAudit,
    canUseSupportTools,
    canOpenSupportDrawer,
  };
};

export const buildTenantSupportPermissions = (capabilities = {}) => ({
  suspend: Boolean(capabilities.canSuspend),
  readOnly: Boolean(capabilities.canReadOnly),
  billingManage: Boolean(capabilities.canManageBilling),
  billingView: Boolean(capabilities.canViewBilling),
  enterTenant: Boolean(capabilities.canEnterTenant),
  ghost: Boolean(capabilities.canStartGhost),
});
